import deutsch from "../locales/deutsch/main.json"
import english from "../locales/english/main.json"
export default (msg,sprache) => {  
  const data = {
    deutsch: deutsch,
    english: english
  }
  // console.log(msg +" "+sprache)
  // console.log(sprache)
  // console.log(data[sprache][msg])
    try{
      var file = data[sprache]
      if(file[msg]=='' || !file[msg] || !file){
        return msg
      }
      return file[msg]
    }catch(e){
      console.log(e)
      return msg
    }
};